<div class="popover-container">
  <div *ngIf="showPopover" class="popover popover-size_{{size}}">
    <button class="btn btn_link popover-close" (click)="closePopover()" svgIcon [icon]="'close'"></button>
    <div>{{ text }}</div>
    <div *ngIf="link.length" class="popover-link" (click)="onLinkClicked()">{{ link }}</div>
  </div>
  <div *ngIf="iconName" class="popover-icon" (click)="openPopover()">
    <i svgIcon [icon]="iconName"></i>
  </div>
</div>
